import AddressItem from 'components/form/AddressSelector/Items/Address/styled';

export default AddressItem;
